window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) {
        console.error('Error loading consent-tracking-api:', error);
        return;
      }
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          "analytics": true,
          "marketing": true,
          "preferences": true,
          "sale_of_data": true,
        },
        () => {
        }
      );
    },
   );
  
  
   function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;SameSite=Lax";
   }
  
   function getCookie(name) {
    const cookieName = name + "=";
    const cookies = document.cookie.split(';');
    for(let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return null;
  }
  
   document.addEventListener('DOMContentLoaded', function() {
    const btnAccept = document.getElementById('acceptAll');
    const gdprContainer = document.querySelector('.gdpr-container');
    const hasCookie = getCookie('gdprConsent');
  
    if (!hasCookie) {
      gdprContainer.classList.add('active');
      btnAccept.addEventListener('click', function() {
        setCookie('gdprConsent', 'true', 365);
        gdprContainer.classList.remove('active');
      });    
    }
  
  
    const toggles = document.querySelectorAll('.toggle-toggle-custom');
    if (toggles.length === 0) return;
    
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function () {
        var checked = toggle.getAttribute('aria-checked') === 'true';
        toggle.setAttribute('aria-checked', !checked);
        toggle.querySelector('.active-icon').setAttribute('aria-hidden', checked);
        toggle.querySelector('.inactive-icon').setAttribute('aria-hidden', !checked);
      });
      
      var checked = toggle.getAttribute('aria-checked') === 'true';
      toggle.querySelector('.active-icon').setAttribute('aria-hidden', checked);
      toggle.querySelector('.inactive-icon').setAttribute('aria-hidden', !checked);
    });
  
  
    const settingBtn = document.getElementById('settings');
    settingBtn.addEventListener('click', function() {
      const vendorsSection = document.querySelector('.gdpr-vendors');
      if (vendorsSection.style.display === 'block') {
        vendorsSection.style.display = 'none';
      } else {
        vendorsSection.style.display = 'block';
      }
    });
  
    const preferenceBtn = document.getElementById('save-preference');
    preferenceBtn.addEventListener('click', function() {
      const vendorsSection = document.querySelector('.gdpr-vendors');
      vendorsSection.style.display = 'none';
      setCookie('gdprConsent', 'true', 365);
      gdprContainer.classList.remove('active');
    });
   });